export const EditorEN = {
    dg_editor: {
        heading: {
            image: "Image",
            video: "Video"
        },
        placeholder: {
            common: "Start typing text",
            title: "Enter title"
        },
        label: {
            title: "Title"
        },
        btn: {
            update: "Update"
        },
       message: {
           error: {
               url: "File does not exist"
           }
       }
    }
}